import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SearchService, DepartureAirport } from '../../services/search.service';
import { log } from 'util';
import * as moment_ from 'moment';

@Component({
  selector: 'ts-search',
  templateUrl: './ts-search.component.html',
  styleUrls: ['./ts-search.component.scss', './style.scss']
})
export class TsSearchComponent implements OnInit, OnChanges {

  // @Input() baseUrl: String = 'https://bookings.fleetwaytravel.com';
  // @Input() baseUrl: String = 'https://semilive.travelsmart.co.uk';
  @Input() baseUrl: String = 'http://travelsmart.uat.fleetway.com';
  // @Input() baseUrl: String = 'http://localhost:3000';

  @Input() isExternal: Boolean = false;

  moment = moment_;
  airports: any[] = [];
  showFromDropdown: Boolean = false;
  showWhereDropdown: Boolean = false;
  showWhenDropdown: Boolean = false;
  showPartyDropdown: Boolean = false;
  minDate = new Date();
  isFormValid: Boolean = true;
  // Loaded from services.
  where: any[] = [];
  destinations: any[] = [];
  dropdownNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
  childrenDropdownNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];

  @Input() selectedAirport: any = {
    name: '',
    codes: []
  };
  @Input() selectedWhere: any = {
    name: '',
    resorts: [],
    selectedResort: 'any'
  };

  @Input() selectedDate: any = '';
  @Input() rooms = [{
    adults: 2,
    children: 0,
    infants: 0
  }];
  guestsTotal = 2;
  resorts: any;
  selectedResort = '';
  isDestinationsLoading: Boolean = true;

  @Input() numberOfAdults: Number = 2;
  @Input() numberOfChildren: Number = 0;
  @Input() duration = 5;
  @Input() country: String = 'UK';

  @Input() isSearching: boolean;
  @Input() lastSearchParams: any;

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onSearch = new EventEmitter();
  @Output() formChange = new EventEmitter();

  constructor(private searchService: SearchService) { }

  ngOnInit() {
    this.searchService.getFrom(this.baseUrl).subscribe(departures => {
      this.airports = this.flattenAirports(departures);
    });
    // this.searchService.getHotels('all', this.baseUrl).subscribe(destinations => {
    //   this.destinations = this.flattenDestinations(destinations);
    // });
    // if (!this.selectedDate) {
    //   this.selectedDate = this.moment().add(7, 'days').format('YYYY-MM-DD');
    // }
    this.updateGuestsTotal();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.selectedAirport) {
      this.selectedAirport = changes.selectedAirport.currentValue;
    }
    if (changes.selectedWhere) {
      this.selectedWhere = changes.selectedWhere.currentValue;
    }
    if (changes.selectedDate) {
      this.selectedDate = changes.selectedDate.currentValue;
    }
    if (changes.duration) {
      this.duration = parseInt(changes.duration.currentValue);
    }
    if (changes.rooms) {
      this.updateGuestsTotal();
    }
  }

  flattenDestinations(destinations) {
    let _destinations: any[] = [];
    for (let i = 0; i < destinations.length; i++) {
      const country = destinations[i];
      _destinations.push({
        name: country.name,
        type: 'country',
        country: country.name
      });
      if (country.regions) {
        for (let j = 0; j < country.regions.length; j++) {
          const region = country.regions[j];
          region.type = 'region';
          region.country = country.name;
          _destinations.push(region);
          for (let k = 0; k < region.resorts.length; k++) {
            const resort = region.resorts[k];
            resort.type = 'resort';
            resort.region = region.name;
            resort.country = country.name;
            _destinations.push(resort);
          }
        }
      }
    }
    return _destinations;
  }

  flattenAirports(airports) {
    let _airports: any[] = [];
    for (let i = 0; i < airports.length; i++) {
      const region = airports[i];
      const codes = [];
      const airportsInRegion = [];
      for (let j = 0; j < region.children.length; j++) {
        const airport = region.children[j];
        codes.push(airport.code);
        airportsInRegion.push({
          name: airport.name,
          type: 'airport',
          codes: [airport.code],
          regions: airport.regions,
          country: region.country
        });
      }
      _airports.push({
        name: region.name,
        country: region.country,
        type: 'region',
        children: region.children,
        codes: codes
      });
      _airports = _airports.concat(airportsInRegion);
    }
    return _airports;
  }

  destinationEnter(event) {
    this.destinationSelected(event);
  }

  changeSelectedDate(event) {
    this.selectedDate = event;
  }


  onSubmit() {
    if (this.selectedAirport.name === '' || this.selectedWhere.name === '' || this.selectedDate === '') {
      this.isFormValid = false;
      return;
    }
    let event = {
      selectedAirport: this.selectedAirport,
      selectedWhere: this.selectedWhere,
      rooms: this.rooms,
      duration: this.duration,
      selectedDate: this.selectedDate,
      baseUrl: this.baseUrl
    };
    this.onSearch.emit(event);
  }



  destinationSelected(event) {
    this.resorts = [];
    if (event === null) {
      this.destinations = [];
      this.selectedWhere = {
        name: '',
        resortName: '',
        resorts: [],
        selectedResort: '',
        type: ''
      };
    } else {
      this.selectedWhere = event;
    }
    this.closeAllDropdowns();
  }

  airpottSelected(event) {
    if (event === null) {
      this.selectedAirport = {
        name: '',
        codes: [],
      };
    } else {
      this.selectedAirport = event;
    }
    this.destinationSelected(null);
    this.closeAllDropdowns();
  }

  onUpdateRoom(event) {
    const rooms = [...this.rooms];
    const room = rooms[event.roomIndex];
    room[event.name] = parseInt(event.value);
    this.rooms = [...rooms];
    this.updateGuestsTotal();
  }

  onAddRoom() {
    this.rooms = [
      ...this.rooms,
      {
        adults: 2,
        children: 0,
        infants: 0,
      }
    ];
    this.updateGuestsTotal();

  }

  updateGuestsTotal() {
    let guestsTotal = 0;
    for (let index = 0; index < this.rooms.length; index++) {
      const room = this.rooms[index];
      guestsTotal = guestsTotal + room.adults;
      guestsTotal = guestsTotal + room.children;
      guestsTotal = guestsTotal + room.infants;
    }
    this.guestsTotal = guestsTotal;
  }

  onRemoveRoom(index) {
    const rooms = [...this.rooms];
    rooms.splice(index, 1);
    this.rooms = rooms;
    this.updateGuestsTotal();

  }

  inputFocus(inputName) {
    this.closeAllDropdowns();
    switch (inputName) {
      case 'from':
        this.showFromDropdown = true;
        break;
      case 'where':
        this.showWhereDropdown = true;
        this.isDestinationsLoading = true;
        if (this.selectedAirport.codes.length > 0) {
          let airports = '';
          for (let index = 0; index < this.selectedAirport.codes.length; index++) {            // airports.concat(this.selectedAirport.codes[index]);
            airports = airports + this.selectedAirport.codes[index];
            if (this.selectedAirport.codes.length !== index + 1) {
              airports = airports + ',';
            }
          }
          this.searchService.getDestinationsByRoute(airports, this.baseUrl).subscribe(destinations => {
            this.destinations = this.flattenDestinations(destinations);
            this.isDestinationsLoading = false;
          });
        } else {
          this.searchService.getHotels('all', this.airports, this.baseUrl).subscribe(destinations => {
            this.destinations = this.flattenDestinations(destinations);
            this.isDestinationsLoading = false;
          });
        }
        break;
      case 'when':
        this.showWhenDropdown = true;
        break;
      case 'duration':
        break;
      case 'party':
        this.showPartyDropdown = true;
        break;
      default:
        break;
    }
  }

  closeAllDropdowns() {
    this.showFromDropdown = false;
    this.showWhereDropdown = false;
    this.showWhenDropdown = false;
    this.showPartyDropdown = false;
  }

}
